module.exports = __webpack_public_path__ + "img/favoriteGray.d1f0570a.svg";